import { useStyletron } from '@thanx/uikit/theme'
import palette from 'constants/palette'
import React from 'react'

type PillTone = 'positive' | 'neutral'

const PILL_COLORS: Record<PillTone, { background: string; color: string }> = {
  positive: { background: palette.nephritis10, color: palette.nephritis },
  neutral: { background: palette.grey10, color: palette.grey70 },
}

const Pill = ({
  tone,
  children,
}: {
  tone: PillTone
  children: React.ReactNode
}) => {
  const [css] = useStyletron()
  return (
    <span
      className={`d-inline-flex align-items-center px-s py-xxs ${css({
        ...PILL_COLORS[tone],
        borderRadius: '4px',
        fontSize: '10px',
        fontWeight: 700,
        letterSpacing: '1px',
        textTransform: 'uppercase',
        whiteSpace: 'nowrap',
        flexShrink: 0,
      })}`}
    >
      {tone === 'positive' && (
        <span
          aria-hidden="true"
          className={css({
            width: '6px',
            height: '6px',
            borderRadius: '50%',
            backgroundColor: palette.nephritis,
            marginRight: '6px',
            flexShrink: 0,
          })}
        />
      )}
      {children}
    </span>
  )
}

export default Pill
